import React from 'react';

export default function AssetProperties({ asset, onAssetPropertyChange }) {
  if (!asset) {
    return (
      <div className="props">
        <div className="props__body">
          <p className="props__empty">No selection</p>
        </div>
      </div>
    );
  }
  return (
    <div className="props">
      <div className="props__header props__text">{asset.name}</div>
      <div className="props__row">
        <label className="props__label">Width</label>
        <span className="props__value">{asset.width}</span>
      </div>

      <div className="props__row">
        <label className="props__label">Height</label>
        <span className="props__value">{asset.height}</span>
      </div>
    </div>
);
}
